export var valuesTryZipToProjectEntryState = ["New", "Replace", "AddVersion", "CannotAdd"];
/*

*/ 
//# sourceMappingURL=TryZipToProjectEntryState.js.map